import axios from 'axios';
import { getAuthHeaders } from '../utils/auth';

const API_BASE_URL = process.env.REACT_APP_API_URI;

// Get all categories with pagination and filtering
export const fetchAllCategories = async (params = {}) => {
  try {
    const { page = 1, limit = 10, sortField, sortOrder, type, search } = params;
    const queryParams = new URLSearchParams({
      page,
      limit,
      ...(sortField && { sortField }),
      ...(sortOrder && { sortOrder }),
      ...(type && { type }),
      ...(search && { search })
    });

    const response = await axios.get(
      `${API_BASE_URL}/api/categories?${queryParams}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error.response?.data || error;
  }
};

// Get category stats
export const getCategoryStats = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/categories/stats`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching category stats:', error);
    throw error.response?.data || error;
  }
};

// Create new category
export const createCategory = async (categoryData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/categories`,
      categoryData,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating category:', error);
    throw error.response?.data || error;
  }
};

// Update category
export const updateCategory = async (id, categoryData) => {
  try {
    const response = await axios.put(
      `${API_BASE_URL}/api/categories/${id}`,
      categoryData,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating category:', error);
    throw error.response?.data || error;
  }
};

// Delete category
export const deleteCategory = async (id) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/api/categories/${id}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error.response?.data || error;
  }
};

export const getCategoryById = async (id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/categories/${id}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching category:', error);
    throw error.response?.data || error;
  }
};

export const getParentCategories = async (type) => {
  try {
    const queryParams = new URLSearchParams({
      type,
      parentOnly: true
    });
    
    const response = await axios.get(
      `${API_BASE_URL}/api/categories/parents?${queryParams}`,
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching parent categories:', error);
    throw error.response?.data || error;
  }
};

export const categoryService = {
  async getCategories(type = 'blog') {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/categories?type=${type}`);
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching categories:', error);
      return null;
    }
  }
}; 